export default __webpack_public_path__ + "static/media/login-bg.56457993.jpg";